export const usePriceBuilder = (data: any) => {
  const { price = 0, max_price = 0, customizations = {}, filter_tags } = data;

  const tagsArray = Array.isArray(filter_tags) ? filter_tags : [];

  const itemMinPrice = tagsArray.find(
    (tag: any) => tag && typeof tag.code === 'string' && tag.code === 'min_price'
  );
  const itemMaxPrice = tagsArray.find(
    (tag: any) => tag && typeof tag.code === 'string' && tag.code === 'max_price'
  );

  // Helper function to safely convert to number
  const safeNumber = (val: any, fallback: number = 0): number => {
    const num = Number(val);
    return isNaN(num) ? fallback : num;
  };

  if (customizations && typeof customizations === 'object' && Object.keys(customizations).length > 0) {
    return {
      price: itemMinPrice ? safeNumber(itemMinPrice.value, price) : safeNumber(price),
      maxPrice: itemMaxPrice ? safeNumber(itemMaxPrice.value, max_price) : safeNumber(max_price),
    };
  }

  return {
    price: safeNumber(price),
    maxPrice: safeNumber(max_price),
  };

  // Safely convert base prices to numbers
  let totalPrice = Number(price);
  let maxPrice = Number(max_price);

  // Helper function to process customization groups recursively
  // const processGroup = (groupId: any) => {
  //   const matchedItem = customizations.customizations?.find((item: any) => item.id === groupId);

  //   if (matchedItem) {
  //     // Find default option within the group
  //     let defaultOption = matchedItem.options?.find((option: any) => option.default.isDefault === 1);

  //      // If default option is invalid or not available, find the next valid option
  //     if (defaultOption && (defaultOption.inventory_quantity === 0 && defaultOption.max_quantity === 0)) {
  //         defaultOption = matchedItem.options?.find(
  //           (option: any) => option.inventory_quantity > 0 && option.max_quantity > 0
  //         );
  //     }

  //     let itemToAdd: any;

  //     if (defaultOption) {
  //       itemToAdd = defaultOption;

  //       // Process child addons group if any
  //       if (defaultOption.child_addons_group && Array.isArray(defaultOption.child_addons_group)) {
  //         defaultOption.child_addons_group.forEach((childGroupId: any) => {
  //           processGroup(childGroupId);
  //         });
  //       }
  //     } else {
  //         // If no default option, handle minimum count logic
  //         // if (matchedItem.min_count === 0 && matchedItem.max_count <= 1 && matchedItem.options?.length > 0) {
  //         //   itemToAdd = matchedItem.options[0];
  //         // }
  //     }

  //     // Add prices for the selected item
  //     if (itemToAdd) {
  //       totalPrice += Number(itemToAdd.price || 0);
  //       maxPrice += Number(itemToAdd.max_price || 0);
  //     }
  //   }
  // };

  const processGroup = (groupId: any) => {
    const matchedItem = customizations.customizations?.find((item: any) => item.id === groupId);

    if (matchedItem) {
      // Find default options within the group
      let defaultOptions = matchedItem.options?.filter((option: any) => option.default.isDefault === 1) || [];

      // If default options are invalid, find the next valid options
      defaultOptions = defaultOptions.filter(
        (option: any) => option.inventory_quantity > 0 && option.max_quantity > 0
      );

      if (defaultOptions.length === 0) {
        // If no default options, handle minimum count logic
        if (matchedItem.min_count > 0) {
          // Select exactly `min_count` items from available options
          const availableOptions = matchedItem.options?.filter(
            (option: any) => option.inventory_quantity > 0 && option.max_quantity > 0
          ) || [];

          if (availableOptions.length >= matchedItem.min_count) {
            defaultOptions = availableOptions.slice(0, matchedItem.min_count);
          }
        }
      }

      // Process selected options
      defaultOptions.forEach((selectedOption: any) => {
        // Add prices for the selected option
        totalPrice += Number(selectedOption.price || 0);
        maxPrice += Number(selectedOption.max_price || 0);

        // Process child addons group if any
        if (selectedOption.child_addons_group && Array.isArray(selectedOption.child_addons_group)) {
          selectedOption.child_addons_group.forEach((childGroupId: any) => {
            processGroup(childGroupId);
          });
        }
      });
    }
  };
  
  // Iterate through custom groups to process each group
  if (customizations.custom_group && Array.isArray(customizations.custom_group)) {
    customizations.custom_group.forEach((groupId: any) => {
      processGroup(groupId);
    });
  } 

  return {
    price: totalPrice,
    maxPrice: maxPrice,
  };
};
